import {useSelector} from 'react-redux'
import {useEffect, useState} from 'react'
import {useHistory, useParams} from 'react-router-dom'
import { RootState } from '../../../../../setup'
import { QueryData } from '../../../../reusable-components/tables/DynamicTableTypes'
import {toast} from 'react-toastify'
import TableTitle from '../../../../reusable-components/tables/TableTitle'
import TableWrapper from '../../../../reusable-components/tables/TableWrapper'
import TableSearchBar from '../../../../reusable-components/tables/TableSearchBar'
import { hasPermission } from '../../../../../_helper/hasPermission'
import { permissions } from '../../../../../_constants/permissions'
import DynamicTable from '../../../../reusable-components/tables/DynamicTable'
import AddButton from '../../../../reusable-components/Buttons/AddButton'
import axios from 'axios'
import { BEHAVIOUR_COLUMNS_DATA_MAPPING,BEHAVIOUR_LISTING_COLUMNS,
  BEHAVIOUR_SORTING_COLUMNS, } from '../../../Notes/Behaviour_Notes/BEHAVIOUR_TABLE_CONSTANTS'
import dayjs from 'dayjs'
const selectAuth = (state: RootState) => state.auth
const selectTimeZone = (state: RootState) => state.timeZone.timeZone

 const DeletedBehaviourNote = () => {
  const [filteredData, setFilteredData] = useState<any[]>([])
  const [fullData, setFullData] = useState<any[]>([])
  const [searchTerm, setSearchTerm] = useState('')
  const [loadingStates, setLoadingStates] = useState({})
  const [deletedID, setDeletedID] = useState('')
  const [isFetchingData, setIsFetchingData] = useState(true)
  const auth = useSelector(selectAuth)
  const userPermissions = auth.user.roleId
  const history = useHistory()
  const [queryData, setQueryData] = useState<QueryData>({
    pageNumber: 1,
    pageSize: 5,
    currentPage: 1,
    totalCounts: 1,
    sortBy: '_id',
    sortDir: 'desc',
    searchTerm: '',
  })
  const {id, clientId, noteType}: {id: string, clientId: string, noteType: string} = useParams()
useEffect(() => {
  const fetchData = async (page: number, pageSize: number, sortBy: string, sortDir: string) => {
    setIsFetchingData(true);
    try {
      const response = await axios.get(`/progressNotes/getAll/${clientId}`, {
        params: {
          noteType: noteType,
          page: page,
          pageSize: pageSize,
          sortBy: sortBy,
          sortDir: sortDir,
          searchTerm: queryData.searchTerm,
          isDeleted: true,
        },
      });
      const { data: result, currentPage, totalCounts } = response.data;
      setFullData(result);
      setQueryData((prevState) => {
        return {
          ...prevState,
          currentPage,
          totalCounts,
        };
      });
      setFilteredData(result);
    } catch (error: any) {
      if (axios.isCancel(error)) {
        console.log('Request canceled', error.message);
      } else {
        console.log('Error:', error.message);
      }
    } finally {
      setIsFetchingData(false);
    }
  };

  fetchData(queryData.pageNumber, queryData.pageSize, queryData.sortBy, queryData.sortDir);
}, [
  deletedID,
  queryData.pageNumber,
  queryData.pageSize,
  queryData.sortBy,
  queryData.sortDir,
  queryData.searchTerm,
]);
  const onUpdate = ({_id}: {_id: string}) => {
    history.push({
      pathname: `/deleted-notes/behaviour-notes/entry/${_id}`,
    })
  }


  return (
    <div className='card'>
      <div className='card-body'>
        <TableTitle title='Behavior Notes' />
        <TableWrapper
          searchField={
            <TableSearchBar
              label='Search'
              variant='outlined'
              size='small'
              value={searchTerm}
              setQueryData={setQueryData}
              setSearchTerm={setSearchTerm}
              margin='normal'
              inputAdornmentPosition='start'
            />
          }
          dynamicTable={
            <DynamicTable
              htmlColumns={[]}
              columns={BEHAVIOUR_LISTING_COLUMNS}
              data={filteredData}
              canUpdate={hasPermission(userPermissions, permissions.notes_behavior_note_entry_update)}
              columnDataMapping={BEHAVIOUR_COLUMNS_DATA_MAPPING}
              sortingColumns={BEHAVIOUR_SORTING_COLUMNS}
              clickableRow={false}
              loadingStates={loadingStates}
              onUpdate={onUpdate}
              setQueryData={setQueryData}
              queryData={queryData}
            />
          }
        />
      </div>
    </div>
  )
}
export default DeletedBehaviourNote